function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTextWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 50,
  viewBox: "0 0 128 100"
}, props), /*#__PURE__*/React.createElement("path", {
  "data-name": "Custom Text",
  d: "M14 78h52a2 2 0 0 1 0 4H14a2 2 0 0 1 0-4Zm0-12h100a2 2 0 0 1 0 4H14a2 2 0 0 1 0-4Zm0-12h90a2 2 0 0 1 0 4H14a2 2 0 0 1 0-4Zm38-22h42a2 2 0 0 1 0 4H52a2 2 0 0 1 0-4Zm0-12h62a2 2 0 0 1 0 4H52a2 2 0 0 1 0-4Zm-16.219-4v6.806h-.689c-.408-1.62-.861-.784-1.358-1.492a5.231 5.231 0 0 0-2.047-1.693 6.555 6.555 0 0 0-2.545-.344h-1.933v18.012a8.173 8.173 0 0 0 .22 2.487 1.97 1.97 0 0 0 .861.87 3.481 3.481 0 0 0 1.751.373h.859v.708H17.318v-.707h.861a3.587 3.587 0 0 0 1.818-.4 1.829 1.829 0 0 0 .784-.918 7.887 7.887 0 0 0 .21-2.411V19.277h-1.875a5.454 5.454 0 0 0-3.807 1.11c-1.11 1.033-1.811.506-2.1 2.419h-.732V16h23.3Z",
  style: {
    fillRule: "evenodd"
  }
}));
SvgTextWidget.displayName = "SvgTextWidget";
export { SvgTextWidget as ReactComponent };
export default SvgTextWidget;